export default __webpack_public_path__ + "static/Mobile-Home-Demolition-4f616189313c8795139c3ec77b7d8473.jpg";